/**
 * Staff Details - Staff Card Component
 * Displays individual staff in grid view
 */
import { Edit2 } from 'lucide-react';

const StaffCard = ({ staff, detail, onView, onEdit }) => {
  const hasDetail = !!detail;
  const personality = detail?.personality || {};
  
  return (
    <div 
      className="bg-white rounded-xl border border-gray-200 p-4 hover:shadow-lg transition-all cursor-pointer"
      onClick={() => onView(staff, detail)}
      data-testid={`staff-card-${staff.id}`}
    >
      <div className="flex items-start gap-4">
        {/* Avatar */}
        <div className="w-14 h-14 rounded-full bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center text-white font-bold text-xl">
          {staff.name?.charAt(0) || 'S'}
        </div>
        
        {/* Info */}
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-gray-800 truncate">{staff.name}</h3>
          <p className="text-sm text-gray-500">{staff.position || 'Tiada Jawatan'}</p>
          <p className="text-xs text-gray-400">{staff.department || 'Tiada Jabatan'}</p>
          
          {/* Badges */}
          <div className="flex flex-wrap gap-1 mt-2">
            <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${
              staff.status === 'Active' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'
            }`}>
              {staff.status}
            </span>
            {personality.leadership_potential && (
              <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${
                personality.leadership_potential === 'High' ? 'bg-amber-100 text-amber-700' :
                personality.leadership_potential === 'Medium' ? 'bg-blue-100 text-blue-700' :
                'bg-gray-100 text-gray-600'
              }`}>
                Leadership: {personality.leadership_potential}
              </span>
            )}
            {personality.colour_brain && (
              <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${
                personality.colour_brain === 'Red' ? 'bg-red-100 text-red-700' :
                personality.colour_brain === 'Blue' ? 'bg-blue-100 text-blue-700' :
                personality.colour_brain === 'Green' ? 'bg-green-100 text-green-700' :
                'bg-yellow-100 text-yellow-700'
              }`}>
                {personality.colour_brain}
              </span>
            )}
            {!hasDetail && (
              <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-700">
                Details Incomplete
              </span>
            )}
          </div>
        </div>
        
        {/* Actions */}
        <button
          onClick={(e) => { e.stopPropagation(); onEdit(staff, detail); }}
          className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          data-testid={`edit-staff-${staff.id}`}
        >
          <Edit2 className="w-4 h-4 text-gray-500" />
        </button>
      </div>
    </div>
  );
};

export default StaffCard;
